
define('ldsh!modules/start/products/landings/status/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 product-status-line">\n    ';
 if (productDetails.isRequest) { ;
__p += '\n    <div class="text-center">\n        <i class="ri-loader-4-fill fa-spin product-spinner"></i>\n    </div>\n    ';
 } else { ;
__p += '\n\n        ';
 if (servicePlan === "freemium") { ;
__p += '\n            <div class="row">\n                <div class="col-md-12 col-lg-12">\n                    <p class="mb-0">\n                        <b class="i18n" data-i18n="PUBLIC.PRODUCTS.REAL_PLAN"></b> <span  class="i18n" data-i18n="PUBLIC.PRODUCTS.LANDINGS.LBL_FREE_VERSION"></span>\n                    </p>\n                    <div class="payments-alert-error mb-10 p-5" style="min-height: 30px;">\n                        <span  class="i18n" data-i18n="[html]PUBLIC.PRODUCTS.LANDINGS.LBL_TRIAL_DAYS" data-i18n-options=\'{"days": "' +
__e( trialDays ) +
'"}\'></span>\n                    </div>\n                </div>\n            </div>\n        ';
 } else { ;
__p += '\n            <div class="row">\n                <div class="col-md-12 col-lg-12">\n                    <p>\n                        <b class="i18n" data-i18n="PUBLIC.PRODUCTS.REAL_PLAN"></b>\n                        <span data-i18n="ACCOUNTS.STATUS.LANDINGS.LBL_' +
__e(servicePlan.toUpperCase() ) +
'"></span>\n                        (' +
__e(formatNumber(productDetails.get('maxVisits'))) +
' <span class="i18n" data-i18n="PAYMENTS.LANDINGS.VISITS"></span>)\n                        ';
 if(servicePlan !== "premium"){ ;
__p += '\n                         - <a href="' +
__e(paymentsUrl) +
'" class="i18n ga-tag" data-i18n="ACCOUNTS.STATUS.LANDINGS.COMPARE_PLAN"\n                            data-gacategory="Conversion" data-gaaction="Planes" data-galabel="Productos_Link_Landing" data-gaevent="eventga"></a>\n                        ';
 } ;
__p += '\n\n                    </p>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-md-12 col-lg-12">\n                    <p><b class="i18n" data-i18n="PUBLIC.PRODUCTS.PRODUCT_LEFT"></b>\n                        <span class="product-number">' +
__e(formatNumber(productDetails.get('maxVisits')- productDetails.get('numVisitors'))) +
'</span>\n                        <span class="i18n" data-i18n="PUBLIC.PRODUCTS.VISITS"></span>\n                </div>\n            </div>\n        ';
 } ;
__p += '\n    ';
 } ;
__p += '\n</div>\n';

}
return __p
};});

